import { render, staticRenderFns } from "./Indikator.vue?vue&type=template&id=33cc8120&"
import script from "./Indikator.vue?vue&type=script&lang=js&"
export * from "./Indikator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports